(() => {
  const money = (value, currency = 'SGD') => {
    const centsRounded = Math.round((value + Math.abs(value) * Number.EPSILON) * 100) / 100;
    return new Intl.NumberFormat('en-SG', {style: 'currency', currency, currencyDisplay: 'code'}).format(centsRounded).replace('SGD', 'S$').replace(/\s/g, '');
  };
  document.querySelectorAll('[data-pryme-cost]').forEach(root => {
    if (root.dataset.costReady) return;
    root.dataset.costReady = 'true';
    const form = root.querySelector('form');
    const examples = JSON.parse(root.querySelector('[data-cost-examples]').textContent);
    const field = name => form.elements.namedItem(name);
    const output = key => root.querySelector('[data-cost-' + key + ']');
    const setCurrency = currency => {
      const select = field('currency');
      if (!select || !currency || !/^[A-Z]{3}$/.test(currency)) return;
      if (![...select.options].some(o => o.value === currency)) {
        const option = document.createElement('option'); option.value = currency; option.textContent = currency; select.append(option);
      }
      select.value = currency;
    };
    const calculate = () => {
      const price = Number(field('price').value), units = Number(field('units').value), daily = Number(field('daily').value);
      const shippingKnown = field('shipping').value.trim() !== '';
      const shipping = shippingKnown ? Number(field('shipping').value) : null;
      const valid = field('price').value.trim() !== '' && Number.isFinite(price) && price >= 0 && Number.isSafeInteger(units) && units > 0 && Number.isFinite(daily) && daily > 0 && (!shippingKnown || (Number.isFinite(shipping) && shipping >= 0));
      const days = units / daily, cost = price / days;
      if (!valid || !Number.isFinite(cost) || !Number.isFinite(cost * 30) || !Number.isFinite((price + (shipping || 0)) / days)) {
        output('value').textContent = '—'; output('days').textContent = '—'; output('month').textContent = '—'; output('delivered').textContent = '—';
        output('error').hidden = false; output('error').textContent = 'Enter a price of zero or more, a whole-number pack count above zero and a daily serving above zero. Delivery must be blank or zero or more.';
        return;
      }
      output('error').hidden = true;
      const currency = field('currency')?.value || 'SGD';
      output('value').textContent = money(cost, currency);
      output('days').textContent = new Intl.NumberFormat('en-SG', {maximumFractionDigits: 2}).format(days) + ' days';
      output('month').textContent = money(cost * 30, currency);
      output('delivered').textContent = shippingKnown ? money((price + shipping) / days, currency) : 'Delivery excluded';
    };
    field('example').addEventListener('change', () => {
      const example = examples.find(item => item.id === field('example').value);
      if (!example) {output('note').textContent = 'Your custom example. Check current seller prices and directions.'; return;}
      ['price', 'units', 'daily', 'shipping'].forEach(name => {field(name).value = example[name] === null ? '' : example[name];});
      setCurrency(example.currency);
      output('note').textContent = example.name + ' · ' + example.terms;
      calculate();
    });
    ['price', 'units', 'daily', 'shipping', 'currency'].forEach(name => field(name)?.addEventListener('input', () => {
      field('example').value = 'custom';
      output('note').textContent = 'Your edited example. Check current seller prices and directions.';
    }));
    field('currency')?.addEventListener('change', calculate);
    document.addEventListener('pryme:reader-result', event => {
      const result = event.detail;
      field('example').value = 'custom';
      ['price', 'units', 'daily', 'shipping'].forEach(name => {field(name).value = result[name] ?? '';});
      if (result.currency) setCurrency(result.currency);
      else if (result.price !== null && result.price !== undefined) field('price').value = '';
      output('note').textContent = (result.name || 'Product details') + ' · ' + (result.note || 'Review the extracted inputs and complete missing details.');
      calculate();
    });
    form.addEventListener('submit', event => {event.preventDefault(); calculate();});
  });
})();
